// Convierte cualquier forma de compartir un video de YouTube en la URL de
// embebido, para previsualizarlo mientras se escribe.
//
// Esto es comodidad de interfaz, NO la defensa: el backend valida y normaliza
// la URL otra vez al guardarla (ver api/utils/enlaces.py). Lo que se guarda es
// siempre lo que decide el servidor, no lo que calcule esta función.

const HOSTS_YOUTUBE = [
    "youtube.com",
    "www.youtube.com",
    "m.youtube.com",
    "youtu.be",
    "youtube-nocookie.com",
    "www.youtube-nocookie.com",
];

// Los ids de YouTube son exactamente 11 caracteres de este alfabeto.
const ID_VALIDO = /^[A-Za-z0-9_-]{11}$/;

// Rutas que llevan el id en el segmento siguiente.
const RUTAS_CON_ID = ["embed", "shorts", "live", "v"];

export function youtubeEmbedUrl(url) {
    if (!url) {
        return null;
    }

    let partes;
    try {
        partes = new URL(String(url).trim());
    } catch (error) {
        // Todavía no es una URL completa: pasa mientras se escribe.
        return null;
    }

    if (partes.protocol !== "http:" && partes.protocol !== "https:") {
        return null;
    }

    const host = partes.hostname.toLowerCase();
    if (HOSTS_YOUTUBE.indexOf(host) === -1) {
        return null;
    }

    const segmentos = partes.pathname.split("/").filter(Boolean);
    let id = null;

    if (host === "youtu.be") {
        id = segmentos[0] || null;
    } else if (segmentos.length === 0 || segmentos[0] === "watch") {
        id = partes.searchParams.get("v");
    } else if (RUTAS_CON_ID.indexOf(segmentos[0]) !== -1 && segmentos.length > 1) {
        id = segmentos[1];
    }

    if (!id || !ID_VALIDO.test(id)) {
        return null;
    }

    // Se reconstruye desde el id en vez de arreglar la URL que llegó: así no
    // sobrevive nada de la query original en el src del iframe.
    return `https://www.youtube.com/embed/${id}`;
}
